import styled from 'styled-components'
import { Pill } from '@dsny/dsny-component-library'
import { releaseInfoMobileDownQuery } from '../../responsiveQueries'

export const ReleaseTitle = styled.h4`
  font-size: 24px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.neutralW90};
`

export const ReleaseArtist = styled.h5`
  font-size: 20px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.neutralW90};
  margin-bottom: 10px;
`

export const Label = styled.span`
  display: flex;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.neutralW80};
`

export const Formats = styled.div`
  margin-top: 10px;
  margin-bottom: 24px;

  span {
    margin-right: 5px;
  }
`

export const ContainsAIPill = styled(Pill)`
  background-color: ${({ theme }) => theme.colors.neutralW30};
  color: ${({ theme }) => theme.colors.neutralW90};
  cursor: pointer;
`

export const ReleaseDetailsContentCol = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  padding: 0 24px;

  @media ${releaseInfoMobileDownQuery} {
    width: 100%;
    flex: 0 0 100%;
  }
`
